<template>
	<div>
		<transition name="list">
  		<div class="chat-container w-100 position-relative">
			<span class="m-0" id="detail"></span>
	    	<!-- title -->
	      <div class="container">
	      	<div class=" position-relative">
					  <div class="row no-gutters justify-content-center">
					    <div class="fixed-top d-block nav-bottom">
					      <div class="custom-container-fluid  px-0">
					        <div class="row justify-content-center no-gutters">
					          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
					            <div class="bg-green">
					              <div class="w-100">
					                <div class="row">
					                  <div class="col-10 py-14px div-wrapper">
					                    <p class="text-white heading-6 mb-0 px-4" style="width: max-content">Ticket Detail </p>
					                  </div>
					                    <div class="col-1 cursor-pointer" @click="backPage()">
					                      <div class="nav-back" style="top: 15px!important;margin-left: -10px!important">
					                        <img src="../../assets/img/icon/cancel.png" width="15">
					                      </div>
					                    </div>
					                </div>
					              </div>
					            </div>
					          </div>
					        </div>
					      </div>
					    </div>
					  </div>
					</div>
	      </div>
	      <div class="mt-8">
	      	<div class="w-100" style="height: 250px !important;">
            <img :src="data.cover_image_url" class="img-fit" height="150">
          </div>
	      </div>
				<div class="container mt-2">
					<div class="px-2">
						<p class="sub-heading-1-1 color-black mb-0 mt-3">{{data.name}}</p>
						<div class="w-100 mt-2">
							<img src="../../assets/img/icon/history.png" class="d-inline-block" width="17">
		          <p class="ml-2 d-inline-block body-2-2-1 mb-0" v-if="data.variants[0].is_refundable">{{$t('merchant.refundable')}}</p>
		          <p class="ml-2 d-inline-block body-2-2-1 mb-0" v-else>{{$t('merchant.non-refundable')}}</p>							
						</div>
						<div class="w-100 mt-2" v-if="data.variants[0].validity_term != null">
		          <img src="../../assets/img/icon/refound.png" class="d-inline-block align-top mr-2" width="17">
		          <div class="d-inline-block align-top w-85">
		          	<p class="body-2-2-1 mb-0">{{data.variants[0].validity_term}}</p>
		          </div>
	        	</div>
						<p class="body-2-2-1 mb-0 mt-3" v-html="data.product_detail"></p>
					</div>
				</div>

				<div class="mt-4" v-if="data.how_to_redeem != ''">
					<div class="container pt-2 mb-2 border-bottom" @click="toggleData('redeem')">
			      <div class="px-2 ">
			        <div class="row">
			          <div class="col-10">
			            <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.how-to-redeem')}}</p>
			          </div>
			          <div class="col-1">
			            <img src="../../assets/img/icon/down-arrow.png" class="d-inline-block text-right" width="18" v-if="data_toggle == 'redeem'">
			            <img src="../../assets/img/icon/down-arrow.png" class="d-inline-block text-right" width="18" v-else style="transform: rotate(180deg);">
			          </div>
			        </div>
			      </div>
			      <div class="px-4">
			        <transition name="list">
			        <p class="body-2-2-1" v-if="data_toggle == 'redeem'" v-html="data.how_to_redeem"></p>
			        </transition>
			      </div>
			    </div>
				</div>

				<div class="mt-4" v-if="data.terms_conditions != ''">
					<div class="container pt-2 mb-2 border-bottom" @click="toggleData('term')">
			      <div class="px-2 ">
			        <div class="row">
			          <div class="col-10">
			            <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.term-condition')}}</p>
			          </div>
			          <div class="col-1">
			            <img src="../../assets/img/icon/down-arrow.png" class="d-inline-block text-right" width="18" v-if="data_toggle == 'term'">
			            <img src="../../assets/img/icon/down-arrow.png" class="d-inline-block text-right" width="18" v-else style="transform: rotate(180deg);">
			          </div>
			        </div>
			      </div>
			      <div class="px-4">
			        <transition name="list">
			        <p class="body-2-2-1" v-if="data_toggle == 'term'" v-html="data.terms_conditions"></p>
			        </transition>
			      </div>
			    </div>
				</div>

				<div class="mt-4" v-if="data.cancellation_policy != ''">
					<div class="container pt-2 mb-2 border-bottom" @click="toggleData('cancel')">
			      <div class="px-2 ">
			        <div class="row">
			          <div class="col-10">
			            <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.cancellation-policy')}}</p>
			          </div>
			          <div class="col-1">
			            <img src="../../assets/img/icon/down-arrow.png" class="d-inline-block text-right" width="18" v-if="data_toggle == 'cancel'">
			            <img src="../../assets/img/icon/down-arrow.png" class="d-inline-block text-right" width="18" v-else style="transform: rotate(180deg);">
			          </div>
			        </div>
			      </div>
			      <div class="px-4">
			        <transition name="list">
			        <p class="body-2-2-1" v-if="data_toggle == 'cancel'" v-html="data.cancellation_policy"></p>
			        </transition>
			      </div>
			    </div>
				</div>		
				<div class="mb-5 pb-3"></div>
				<div class="py-0 fixed-bottom z-index-1028" v-if="getMerchant().merchant_category_name == 'ACTIVITIES'" style="bottom: 8%;">
		      <div class="w-100">
		        <b-row class="justify-content-center" no-gutters>
		          <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="py-2 bg-white">
		            <div class="w-100">
		              <b-row no-gutters>
		                <div class="container bg-white pb-2">
		                  <div class="row">
		                    <div class="col-7">
		                      <p class="mb-0 body-3-3-1 text-black" style="margin-bottom: -7px !important;">{{$t('general.price')}}</p>
		                      <template v-if="data.variants[0].discount == 0">
		                      	<p class="mb-1 mt-1 sub-heading-1-2 text-color-orange">{{formatCurrency(data.variants[0].price_sell_discount)}}</p>
		                      </template>
		                      <template v-else>
			                      <p class="mb-0 d-inline-block body-3-3-1 text-line-through" style="color: #9BA1AA">{{data.variants[0].price_sell}}</p>
			                      <p class="mb-1 sub-heading-1-2 text-color-orange">{{formatCurrency(data.variants[0].price_sell_discount)}}</p>
		                      </template>
		                    </div>
		                    <div class="col-5">
	                        <button v-if="!is_available" class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green" style="background-color: #EFEFEF" >Out of Stock</button>
	                        <p v-else class="mb-0 body-2-4 text-white bg-orange text-center mt-2 mx-auto rounded-10 " @click="addVariantToCart()" style="padding-top: 13px;padding-bottom: 13px;">{{$t('general.select')}}</p>
		                    </div>
		                  </div>
		                </div>
		              </b-row>
		            </div>
		          </b-col>
		        </b-row>
		      </div>
		    </div>
	    </div>
		</transition>
	</div>
</template>
<script>
import {mapGetters,mapActions} from 'vuex';
import {formatCurrency,inputCustomOnly} from '@/utils/index.js';
export default {
  data () {
    return {
    	data_toggle: '',
    	data: {},
    	is_available: false
    }
  },
  mounted(){
  	document.getElementById('detail').scrollIntoView({
        behavior: 'smooth'
    });
  	this.checkTicketAvailability()
  },
  created(){
  	this.data = this.getTicketList().find(x => x.id == this.$route.params.ticket_id);
  },
 	methods: {
 		...mapGetters(['getTicketList','getMerchant']),
 		...mapActions(['ticketAddItemCart']),
 		formatCurrency(data){
			return formatCurrency(data)
		},
 		toggleData(data){
 			if (this.data_toggle == data) {
 				this.data_toggle = ''
 			}else{
 				this.data_toggle = data
 			}
 		},
 		backPage(){
 			this.$router.push({
 				path: '/'+this.getMerchant().code+'/list'
 			})
 		},
 		addVariantToCart(){
 			if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
					let ticket = {
						ticket: this.data,
						variant: this.data.variants[0]
					}
					delete ticket.ticket.variants
					this.ticketAddItemCart(ticket)
 			}else{
				for(let i = 0; i < this.data.variants.length; i++){
					if (this.data.variants[i].availability > 0) {
						
						let ticket = {
							ticket: this.data,
							variant: this.data.variants[i]
						}
						delete ticket.ticket.variants
						this.ticketAddItemCart(ticket)

						break;
					}
				}
 			}
			this.backPage()
		},
		checkTicketAvailability(){
			if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
				this.is_available = (this.data.min_availability > 0) ? true : false
			}else{
				for(let i = 0; i < this.data.variants.length; i++){
					if (this.data.variants[i].availability > 0) {
						this.is_available = true;
						break;
					}
				}
			}
		}
  }
}
</script>
<style scoped>
	.pop-up{
		height: 100vh;
		overflow: scroll;
	}

  .list-enter,
  .list-leave-to {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.3s;
  }

  .w-85{
  	width: 85% !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/TicketDetail.vue